import { LinkConnection } from "../Topology/LinkConnection";
import { TopoNode } from "../Topology/TopoNode";
import { MultiNode } from "../Topology/MultiNode";
import { Link } from "../Core/Link";

export class MultiNodeConnection extends LinkConnection
{
	public get Node(): TopoNode {
		return this.MultiNode;
	}
	public MultiNode: MultiNode;
	public Description: string;

	constructor(node: MultiNode, link: Link) {
		super(link);
		this.MultiNode = node;
		this.Description = "";
	}

	public get DisplayName(): string {
		return this.Description;
	}
}
